module.exports = __webpack_public_path__ + "static/media/primeIT.10c996dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/primeIT.png
// module id = 284
// module chunks = 1